<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import {
  queryCompanyList,
  dkdj_query,
  setBusinessMatchStatus,
  ywlxquery
} from "../../../../api/dkdj_iinv.js";
import config from "../../../../../configHttp.js";
import {comMapping} from "@/components/util/Function/comMapping";

export default {
  data: function () {
    return {
      formateBusinessTypes: [],
      disasSociates: [{label: '未匹配', value: '0'}, {label: '暂不处理', value: '2'}, {label: '匹配完成', value: '1'}],
      headData: getdata().headData,
      searchdiag: false,
      searchlist: getdata().searchlist,
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0
    };
  },
  created() {
    if (this.resSearchdata) {
      this.searchdata = this.resSearchdata;
    }
    this.getData();
    this.loadData();
  },
  mounted() {
  },
  components: {},
  methods: {
    geOoverLength(e) {
      this.overlength = e;
    },
    loadData() {
      queryCompanyList().then(res => {
        if (res.data.code === 1) {
          let companyCodeVal = [];
          for (let i = 0; i < res.data.data.length; i++) {
            companyCodeVal.push({label: res.data.data[i].companyCode, value: res.data.data[i].companyCode})
          }
          this.searchlist[8].selectval = companyCodeVal;
          this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
        } else {
          this.$message.error(res.data.msg)
        }
      });
      ywlxquery({resRange: "1", bsType: "2"}).then((res) => {
        if (res.data.code === "1") {
          this.formateBusinessTypes = res.data.data;
        }
      });
    },
    getData() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum
      params.size = this.pagination.pageSize
      dkdj_query(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.pagination.paginationkey++;
        this.tableData = res.data.data.records;
      });
    },
    setBusinessMatchStatus(status) {
      // 设置处理状态
      let chooseItem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择数据");
        return false;
      }
      for (let i = 0; i < chooseItem.length; i++) {
        // 1. 设置为未匹配：若有匹配凭证的数据操作，提示“关联凭证的数据请至数据处理中心取消关联！”
        if (status === "0" && chooseItem[i].voucherNo) {
          this.$message.error("关联凭证的数据请至数据处理中心取消关联!");
          return false;
        }
        // 2. 设置为暂不处理：仅允许未匹配的数据操作，否则提示“请选择匹配状态为未匹配的数据！”
        if (status === "2" && chooseItem[i].businessMatchStatus !== "0") {
          this.$message.error("请选择匹配状态为未匹配的数据!");
          return false;
        }
        // 3. 设置为匹配完成：所有匹配状态均允许置为匹配完成
        if (status === "1" && chooseItem[i].businessMatchStatus === "1") {
          this.$message.error("请选择未匹配完成的数据!");
          return false;
        }
      }
      let ids = chooseItem.map((item) => item.id);
      setBusinessMatchStatus({daikdjIds: ids, status: status}).then((res) => {
        if (res.data.code === 1) {
          this.getData();
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    exportDkdj() {
      // 导出
      // 得到勾选的列表值：
      let chooseItem = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (chooseItem.length > 0) {
        data.ids = chooseItem.map((item) => item.id);
      } else {
        data.searchInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "/iinvWithheld/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          failUrl: this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    // 处理状态format
    businessMatchStatusFormat(val) {
      let item = comMapping.$businessMatchStatus.find(status => status.value === val);
      return item ? item.label : val;
    },
    // 业务类型format
    businessTypeFormat(val) {
      let item = this.formateBusinessTypes.find(status => status.value === val);
      return item ? item.label : val;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange() {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getData();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getData();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
